export default __webpack_public_path__ + "static/media/navbar-ring.f50dbd52.svg";